// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGDICOMDeleteIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGDICOMDeleteIcon extends PureComponent<
  ISVGDICOMDeleteIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        width="25px"
        height="25px"
        viewBox="0 0 25 25"
        enableBackground="new 0 0 25 25"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M17.739,4.717c-0.792,0-1.585,0-2.377,0c0-0.792,0-1.585,0-2.377
	c-3.649,0-7.299,0-10.948,0c0,0.018,0,0.037,0,0.055c0.037,0,0.074,0,0.11,0c0.404,0.301,0.999,0.349,1.493,0.553
	c1.033,0.428,2.175,0.844,3.207,1.272c0.254,0.105,1.329,0.347,1.438,0.498c0,4.718,0,9.437,0,14.155c1.566,0,3.133,0,4.7,0
	c0-0.793,0-1.585,0-2.378c0.774,0,1.548,0,2.322,0c0.221,0.662,0.06,1.822,0.055,2.599c-0.094,0.146-0.04,0.365-0.111,0.553
	c-0.166,0.443-0.564,0.972-0.94,1.217c-1.058,0.69-4.291,0.398-6.027,0.387c0,1.161,0,2.322,0,3.483
	c-0.809-0.086-1.633-0.646-2.322-0.94c-1.85-0.792-3.716-1.491-5.529-2.268c-1.052-0.45-2.145-0.622-2.599-1.658
	c-0.341-0.78-0.166-2.268-0.166-3.318c0-2.414,0-4.829,0-7.243c0-1.806,0-3.612,0-5.418c0-1.59-0.022-2.774,0.885-3.428
	C1.753-0.134,3.381,0.017,4.8,0.017c2.82,0,5.641,0,8.46,0c1.578,0,3.039-0.116,3.815,0.664C17.866,1.475,17.752,3.112,17.739,4.717
	z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M20.061,11.794c-2.359,0-4.719,0-7.077,0c0-0.773,0-1.548,0-2.322
	c0.579-0.191,1.579-0.055,2.267-0.055c1.604,0,3.207,0,4.811,0c0-1.161,0-2.323,0-3.484c0.037,0,0.073,0,0.11,0
	c1.124,1.143,2.249,2.286,3.373,3.428c0.347,0.347,1.104,0.797,1.216,1.327c-1.143,1.124-2.285,2.249-3.428,3.373
	c-0.359,0.359-0.771,1.036-1.271,1.217C20.061,14.117,20.061,12.956,20.061,11.794z"
        />
      </svg>
    );
  }
}
